import { gql } from '@apollo/client';

export const InternalPageLinkFragment = gql(`
    fragment InternalPageLinkFragment on InternalPageLink {
        __typename
        sys {
            id
        }
        linkText
        linkPage {
            ... on PageCaseStudy {
                __typename
                sys {
                    id
                }
                slug
            }
            ... on PageIndustry {
                __typename
                sys {
                    id
                }
                slug
            }
            ... on PageLanding {
                __typename
                sys {
                    id
                }
                slug
            }
            ... on PagePerson {
                __typename
                sys {
                    id
                }
                slug
            }
            ... on PageService {
                __typename
                    sys {
                    id
                }
                slug
            }
        }
    }
`);
